export const AccessToken =
  "eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI3MWEwNTNlMjdlYzc4ODYzZTA3ZGQ2OWY1ZDg2OGUxMyIsInN1YiI6IjYwN2MwOWI1NzEzZWQ0MDA3ZDBhZWY2ZCIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.eGGWaw9V_pY7-78v4CTj9BG88lAaEykCBRDV_PuwksU";

export const imgBaseUrl = "https://image.tmdb.org/t/p";
